import { useState } from "react";
import { HelpCircle, ChevronDown } from "lucide-react";
import { useOutletContext } from "react-router-dom";
import { helpFor } from "@/lib/helpContent";
import { industryOf, vt } from "@/lib/industry";

export const useHelp = () => {
  const ctx = useOutletContext();
  return helpFor(ctx?.builder ? industryOf(ctx.builder) : vt().id);
};

export function HelpSections({ topic, dark = false }) {
  const t = useHelp()[topic];
  if (!t) return null;
  return (
    <div className="space-y-4">
      <p className={`text-sm ${dark ? "text-white/70" : "text-slate-600"}`}>{t.intro}</p>
      {t.sections.map(([h, items]) => (
        <div key={h}>
          <p className={`font-semibold text-sm ${dark ? "text-white" : "text-slate-900"}`}>{h}</p>
          <ul className={`mt-1 space-y-1 text-sm ${dark ? "text-white/70" : "text-slate-600"}`}>
            {items.map((x) => <li key={x} className="flex gap-2"><span className={`mt-2 w-1.5 h-1.5 rounded-full shrink-0 ${dark ? "bg-white/40" : "bg-ba"}`} />{x}</li>)}
          </ul>
        </div>
      ))}
    </div>
  );
}

export function HelpBox({ topic }) {
  const key = `help_open_${topic}`;
  const [open, setOpen] = useState(() => localStorage.getItem(key) !== "0");
  const HELP = useHelp();
  const toggle = () => { localStorage.setItem(key, open ? "0" : "1"); setOpen(!open); };
  if (!HELP[topic]) return null;
  return (
    <div className="rounded-3xl border border-amber-200 bg-amber-50/60 mb-8" data-testid={`help-box-${topic}`}>
      <button onClick={toggle} className="w-full flex items-center gap-2 px-5 py-3 text-left text-sm font-semibold" data-testid={`help-toggle-${topic}`}>
        <HelpCircle className="w-4 h-4 text-ba" />How this works: {HELP[topic].title}
        <ChevronDown className={`w-4 h-4 ml-auto transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <div className="px-5 pb-5"><HelpSections topic={topic} /></div>}
    </div>
  );
}
